<template>
    <div>
        <SroiComponent/>
    </div>
</template>

<script>
import SroiComponent from "../components/DataComponents/SroiComponent.vue";

export default {
  name: "sroi-data-view",
  components: { SroiComponent },
  title: 'SROI',
}
</script>